export const initialEditorState = {
  enabled: true,
  mode: "edit",
  geom_type: "",
  id: "",
  history: [],
  historyIndex: 0,
  activeLayers: [],
  modelLayers: [],
  name: "",
  isDrawing: false,
  loading: false,
  tcSettingsMode: "create",
  currentGCPoint: null,
  editingCallback: null,
  multi: false,
  multiFeatures: [],
  updated: false
};

const trafficCountsTextvalue = [
  "format",
  ["get", "label_c"],
  { "text-color": "rgba(85, 183, 126, 1)" },
  "-",
  { "text-color": "rgba(255,255,255, 1)" },
  ["get", "label_g"],
  { "text-color": "rgba(145, 94, 255, 1)" },
  "-",
  { "text-color": "rgba(255,255,255, 1)" },
  ["get", "label_b"],
  { "text-color": "rgba(255, 76, 141, 1)" },
  "-",
  { "text-color": "rgba(255,255,255, 1)" },
  ["get", "label_t1"],
  { "text-color": "rgba(248, 195, 72, 1)" },
  "-",
  { "text-color": "rgba(255,255,255, 1)" },
  ["get", "label_t2"],
  { "text-color": "rgba(229, 101, 102, 1)" },
  " (",
  { "text-color": "rgba(255,255,255, 1)" },
  ["get", "total"],
  { "text-color": "rgba(255,255,255, 1)" },
  ")",
  { "text-color": "rgba(255,255,255, 1)" }
];

export const initialFillState = {};

export const trafficCountsLayersConfig = {
  // basic types
  nodes: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": 3,
      "circle-color": "#3A8FD2",
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "#fff",
      "circle-stroke-width": 1
    }
  },
  links: {
    type: "line",
    layout: {
      "line-join": "round",
      "line-cap": "round"
    },
    paint: {
      "line-color": "#3A8FD2",
      "line-width": 1
    }
  },
  // turns
  turns: {
    type: "line",
    layout: {
      "line-join": "round",
      "line-cap": "round"
    },
    paint: {
      "line-color": "rgb(255, 68, 140)",
      "line-width": ["interpolate", ["linear"], ["get", "total"], 0, 2, 750, 20]
    }
  },
  turns_arrow_label: {
    type: "symbol",
    layout: {
      "symbol-placement": "line",
      "text-field": "▶",
      "text-size": ["interpolate", ["linear"], ["zoom"], 12, 14, 22, 18],
      "symbol-spacing": ["interpolate", ["linear"], ["zoom"], 12, 24, 22, 32],
      "text-keep-upright": false
    },
    paint: {
      "text-color": "rgb(255, 68, 140)",
      "text-halo-color": "#fff",
      "text-halo-width": 1
    }
  },
  turns_arrows: {
    type: "symbol",
    layout: {
      "icon-image": "arrow",
      "icon-size": 0.35,
      "icon-rotate": ["get", "rotate"],
      "icon-pitch-alignment": "map"
    },
    paint: {
      "text-color": "#3887be"
    }
  },
  turns_text: {
    type: "symbol",
    layout: {
      "text-field": [
        "case",
        ["==", ["get", "total"], 0],
        ["format", "0", { "text-color": "rgba(255, 255, 255, 1)" }],
        trafficCountsTextvalue
      ],
      "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
      "text-size": 16,
      "text-pitch-alignment": "map",
      "symbol-placement": "line-center",
      "text-letter-spacing": 0.1,
      "symbol-sort-key": 1
    },
    paint: {
      "text-halo-color": "#242730",
      "text-halo-width": 1.5
    }
  },
  // direct and reverse
  direct_arrow: {
    type: "line",
    layout: {
      "line-join": "round",
      "line-cap": "round"
    },
    paint: {
      "line-color": "rgb(255, 68, 140)",
      "line-width": ["interpolate", ["linear"], ["get", "total"], 0, 2, 750, 10]
    }
  },
  reverse_arrow: {
    type: "line",
    layout: {
      "line-join": "round",
      "line-cap": "round"
    },
    paint: {
      "line-color": "rgb(255, 68, 140)",
      "line-width": ["interpolate", ["linear"], ["get", "total"], 0, 2, 750, 10]
    }
  },
  direct_arrow_label: {
    type: "symbol",
    layout: {
      "text-field": ["get", "total"],
      "text-pitch-alignment": "map",
      "text-rotation-alignment": "map",
      "symbol-placement": "line-center",
      // "text-offset": [0, -1.5],
      "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
      "text-size": 18,
      "text-letter-spacing": 0.1
    },
    paint: {
      "text-color": "rgb(255, 68, 140)",
      "text-halo-color": "#242730",
      "text-halo-width": 1.5
    }
  },
  reverse_arrow_label: {
    type: "symbol",
    layout: {
      "text-field": ["get", "total"],
      "text-pitch-alignment": "map",
      "text-rotation-alignment": "map",
      "symbol-placement": "line-center",
      // "text-offset": [0, 1.5],
      "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
      "text-size": 18,
      "text-letter-spacing": 0.1
    },
    paint: {
      "text-color": "rgb(255, 68, 140)",
      "text-halo-color": "#242730",
      "text-halo-width": 1.5
    }
  },
  // gcp and cp
  general_count_points: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": 10,
      "circle-color": "#e56566",
      "circle-opacity": 0.7,
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "#fff",
      "circle-stroke-width": 1
    }
  },
  general_count_points_label: {
    type: "symbol",
    layout: {
      "text-field": ["get", "no"],
      "text-pitch-alignment": "map",
      "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
      "text-size": 18,
      "text-letter-spacing": 0.1
    },
    paint: {
      "text-color": "#fff",
      "text-halo-color": "#242730",
      "text-halo-width": 1.5
    }
  },
  count_points: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": 5,
      "circle-color": "#e56566",
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "#fff",
      "circle-stroke-width": 1
    }
  },
  count_points_label: {
    type: "symbol",
    layout: {
      "text-field": ["get", "name"],
      "text-pitch-alignment": "map",
      "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
      "text-size": 16,
      "text-letter-spacing": 0.1
    },
    paint: {
      "text-color": "#fff",
      "text-halo-color": "#242730",
      "text-halo-width": 1.5
    }
  }
};

export const gcpTypes = [
  { id: 1, value: 1, name: "По подходам" },
  { id: 2, value: 2, name: "По направлениям" }
];
export const gcpIntervals = [
  { id: 1, value: 86400, name: "Суточный" },
  { id: 2, value: 60, name: "Часовой" },
  { id: 3, value: 15, name: "15-ти минутный" }
];
export const hourIntervals = [
  { value: 1, name: "00:00 - 01:00" },
  { value: 2, name: "00:30 - 01:30" },
  { value: 3, name: "01:00 - 02:00" },
  { value: 4, name: "01:30 - 02:30" },
  { value: 5, name: "02:00 - 03:00" },
  { value: 6, name: "02:30 - 04:30" },
  { value: 7, name: "03:00 - 04:00" },
  { value: 8, name: "03:30 - 04:30" },
  { value: 9, name: "04:00 - 05:00" },
  { value: 10, name: "04:30 - 05:30" },
  { value: 11, name: "05:00 - 06:00" },
  { value: 12, name: "05:30 - 06:30" },
  { value: 13, name: "06:00 - 07:00" },
  { value: 14, name: "06:30 - 07:30" },
  { value: 15, name: "07:00 - 08:00" },
  { value: 16, name: "07:30 - 08:30" },
  { value: 17, name: "08:00 - 09:00" },
  { value: 18, name: "08:30 - 09:30" },
  { value: 19, name: "09:00 - 10:00" },
  { value: 20, name: "09:30 - 10:30" },
  { value: 21, name: "10:00 - 11:00" },
  { value: 22, name: "10:30 - 11:30" },
  { value: 23, name: "11:00 - 12:00" },
  { value: 24, name: "11:30 - 12:30" },
  { value: 25, name: "12:00 - 13:00" },
  { value: 26, name: "12:30 - 13:30" },
  { value: 27, name: "13:00 - 14:00" },
  { value: 28, name: "13:30 - 14:30" },
  { value: 29, name: "14:00 - 15:00" },
  { value: 30, name: "14:30 - 15:30" },
  { value: 31, name: "15:00 - 16:00" },
  { value: 32, name: "15:30 - 16:30" },
  { value: 33, name: "16:00 - 17:00" },
  { value: 34, name: "16:30 - 17:30" },
  { value: 35, name: "17:00 - 18:00" },
  { value: 36, name: "17:30 - 18:30" },
  { value: 37, name: "18:00 - 19:00" },
  { value: 38, name: "18:30 - 19:30" },
  { value: 39, name: "19:00 - 20:00" },
  { value: 40, name: "19:30 - 20:30" },
  { value: 41, name: "20:00 - 21:00" },
  { value: 42, name: "20:30 - 21:30" },
  { value: 43, name: "21:00 - 22:00" },
  { value: 44, name: "21:30 - 22:30" },
  { value: 45, name: "22:00 - 23:00" },
  { value: 46, name: "22:30 - 23:30" },
  { value: 47, name: "23:00 - 00:00" }
];
